import React, { memo } from 'react';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import FolderOpen from '@mui/icons-material/FolderOpen';
import LinkIcon from '@mui/icons-material/Link';

export type SwaggerSource = 'uploaded' | 'url';

const SOURCES = [
  { id: 'uploaded', label: 'Uploaded file', Icon: FolderOpen },
  { id: 'url', label: 'From URL', Icon: LinkIcon },
] as const;

interface SourceTabsProps {
  value: SwaggerSource;
  onChange: (value: SwaggerSource) => void;
}

/** Segmented control choosing where the spec comes from. */
const SourceTabs: React.FC<SourceTabsProps> = ({ value, onChange }) => (
  <Box role="tablist" aria-label="Swagger source" sx={{ display: 'flex', gap: '2px', p: '3px', borderRadius: 2.5, bgcolor: 'action.hover' }}>
    {SOURCES.map(({ id, label, Icon }) => {
      const active = id === value;
      return (
        <ButtonBase
          key={id}
          role="tab"
          aria-selected={active}
          onClick={() => onChange(id)}
          sx={{
            height: 34,
            pl: 1.25,
            pr: 1.75,
            gap: 0.75,
            borderRadius: 2,
            fontSize: 13,
            fontWeight: 600,
            color: active ? 'text.primary' : 'text.secondary',
            bgcolor: active ? 'background.paper' : 'transparent',
            boxShadow: active ? '0 1px 3px rgba(0,21,41,.12)' : 'none',
          }}
        >
          <Icon sx={{ fontSize: 18 }} />
          {label}
        </ButtonBase>
      );
    })}
  </Box>
);

export default memo(SourceTabs);
